import React, { useState } from 'react';
import { Form, Field, Formik } from 'formik';

import Account from 'web/components/Account';
import FormContainer from 'web/components/FormContainer';
import RadioButton from 'web/components/form-elements/RadioButton';
import DebitCard from './debit-card';
import AccountDetail from './account-detail';
import styles from './paymentMethod.module.scss';

const PaymentMethod = () => {
  const [paymentType, setPaymentType] = useState('0');
  const radioTypes = [
    {
      value: '0',
      label: 'Bank Account',
    },
    {
      value: '1',
      label: 'Debit Card',
    },
  ];

  const onChangeHandler = (e) => {
    setPaymentType(e.target.value);
  };
  const INITIAL_VALUES = {
    accountType: '0',
  };
  return (
    <Account>
      <FormContainer>
        <div className={styles.sellerContainer}>
          <div className={styles.fieldGroup}>
            <div>
              <p className={styles.ptmMth}>Payment Method</p>
            </div>
            <div className='d-flex'>
              <Formik initialValues={INITIAL_VALUES}>
                {(props) => {
                  const { values, setFieldValue, isValid, dirty } = props;
                  return (
                    <>
                      <Form>
                        {radioTypes &&
                          radioTypes.map((value, index) => (
                            <div key={index}>
                              <Field
                                component={RadioButton}
                                name='accountType'
                                id={value.value}
                                defaultValue={radioTypes[0].value}
                                onSelect={(e) => onChangeHandler(e)}
                                label={value.label}
                              />
                            </div>
                          ))}
                      </Form>
                    </>
                  );
                }}
              </Formik>
            </div>
          </div>
          {paymentType === '0' ? <AccountDetail /> : <DebitCard />}
        </div>
      </FormContainer>
    </Account>
  );
};
export default PaymentMethod;
